export default "__VITE_ASSET__CyHkIYyc__"